import React from "react";
import "./index.css";
import { render } from "react-dom";
import { App } from "./App";
import { injectRadixColors } from "./components/ColorData";

// Inject Radix colors for our demo
injectRadixColors();
render(<App data-id="element-112" />, document.getElementById("root"));